<template>
  <div class="d-flex">
    <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Filtro de Secao</div>

    <v-autocomplete
      :items="listaDeSecao"
      item-text="descricao_secao"
      item-value="id_secao"
      multiple
      outlined
      hide-details
      :placeholder="primairaSecaoSelecionada ? '' : 'Nenhum selecionado'"
    >
      <template v-slot:prepend-item>
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="todosSelecionados">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todos as seções</span>
          </template>
          <template v-else>
            <v-icon v-if="!secaoSelecionadas.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todos as seções</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:item="{item}">
        <v-list-item class="item-list px-3" @click="addOuRemoveItem(item)">
          <v-list-item-icon>
            <v-icon v-if="secaoSelecionado(item)" color="primary">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n6">
            <v-list-item-title>{{item.id_secao}} - {{ item.descricao_secao }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:prepend-inner v-if="secaoSelecionadas.length > 0">
        <v-chip dense class="ma-0 mt-n1">{{ primairaSecaoSelecionada }}</v-chip>
      </template>

      <template v-slot:append>
        <template v-if="secaoSelecionadas.length > 1">
          <v-chip small outlined color="#666666" style="height: 20px">
            + {{ `${secaoSelecionadas.length} selecionados`}}
          </v-chip>
        </template>
        <template v-else>
          <v-icon>mdi-filter</v-icon>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import mixin from '../MixinDRP'

export default {
  name: "filtroDeSecao",
  model: {
    prop: 'secaoSelecionadas',
    event: 'change-secao'
  },
  props: {
    secaoSelecionadas: {
      type: Array,
      required: true
    },
    itensFull: {
      type: Array,
      required: false
    }
  },
  mixins: [mixin],
  computed: {
    listaDeSecao () {
      return this.itensFull;
    },
    todosSelecionados () {
      return this.secaoSelecionadas.length > 0 && this.secaoSelecionadas.length === this.listaDeSecao.length
    },
    primairaSecaoSelecionada () {
      if (this.secaoSelecionadas.length === 0) return 0;

      return this.secaoSelecionadas[0].descricao_secao.trim();
    }
  },
  methods: {
    secaoSelecionado (item) {
      const selecionado = this.secaoSelecionadas.filter(forn => forn.id_secao == item.id_secao)

      return selecionado.length > 0
    },
    selecionarSecao (ev) {
      this.$emit('change-secao', ev)
    },
    selecionarTodos () {
      if (this.todosSelecionados) {
        this.selecionarSecao([])
      } else {
        this.selecionarSecao(this.listaDeSecao)
      }
    },
    addOuRemoveItem (item) {
      let novosSelecionados

      if (this.secaoSelecionado(item)) {
        novosSelecionados = this.secaoSelecionadas.filter(secao => secao.id_secao != item.id_secao)
      } else {
        novosSelecionados = this.secaoSelecionadas.concat(item)
      }

      this.selecionarSecao(novosSelecionados)
    }
  }
}
</script>

<style scoped>
.txt-primeiro-selecionado {
  font-size: 13px;
  white-space: nowrap;
  width: 13em;
}
</style>
